



































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import DateRangePicker from '../../components/DateRangePicker.vue'
import EditOrderDialog from '@/components/admin/EditOrderDialog.vue'

import { Status } from '@/enums/status'

/* eslint-disable */ 
import { Order } from '@/models/Order'
import { DateTime } from 'luxon'
/* eslint-enable */


export default Vue.extend({

  data() {
    return {
      headers: [
        {
          text: 'Order ID',
          align: 'start',
          value: 'id',
        },
        { text: 'Customer Name', value: 'customer.firstName' },
        { text: 'Order Date', value: 'createdAt' },
        { text: 'Subtotal', value: 'subtotal' },
        { text: 'Profit', value: 'profit'},
        { text: '', value: 'actions', sortable: false }
      ],
      dateRange: {
        startDate: null as Date,
        endDate: null as Date
      },
      loading: false,
      dealerOrders: [] as Order[],
      options: {},
      search: '' as string,
      totalOrders: 0,
      sortBy: 'updatedAt',
      sortDesc: true,
      editOrderDialog: false as boolean,
      deleteOrderDialog: false as boolean,
      selectedOrder: null as Order,
      range: [] as string[]
    }
  },
  computed: {
    ...mapGetters({
      currentDealerId: 'dealers/currentDealerId'
    }),
    cartItems() : number {
      return this.dealerOrders.filter((order: Order) => order.statusId == Status.CART).length
    },
    finishedOrders() : Order[] {
      return this.dealerOrders.filter((order: Order) => order.statusId == Status.ORDER)
    },
    orderSize() : string {
      const carts = this.dealerOrders.filter((order: Order) => order.statusId == Status.ORDER)
      let sum = 0
      let numOrders = 0
      carts.forEach((order: Order) => {
        sum = sum + order.subtotal
        numOrders++
      })
      
      return numOrders === 0 ? '0.00' : (sum / numOrders).toFixed(2)
    }
  },
  methods: {
    async requestOrders([start, end] : string[]) {
      this.loading = true
      this.range = [start, end]
      const res = await Order.getOrders(null, this.currentDealerId, start, end)
      this.dealerOrders = res
      this.totalOrders = res.length
      this.loading = false
    },
    parseDateTime(time: string) : string {
      const date = DateTime.fromISO(time)
      return date.toLocaleString({ month: 'long', day: 'numeric' }) + ', ' + date.year
    },
    getOrderProfit(order: Order) : number {
      return order.profit
    },
    openOrderDialog(item: any) {
      this.selectedOrder = JSON.parse(JSON.stringify(item))
      this.editOrderDialog = true
    },
    deleteOrder(item: any) {
      this.loading = true
      Order.deleteOrder(item)
      this.requestOrders(this.range)
      this.loading = false
      this.deleteOrderDialog = false

    },
    closeOrderDialog() {
      this.editOrderDialog = false
      this.requestOrders(this.range)
    },
    handleClick(item: Order) {
      this.selectedOrder = item
      this.deleteOrderDialog = true
    },
  },
  components: {
    DateRangePicker,
    EditOrderDialog
  }
})
